<div class="betbuilder-help-page" msOutsideInteractionExclude=".modal-dialog-header-wrapper,.header-title" (msOutsideInteraction)="close()">
    <div class="help-page-heading" *ngIf="showHeader" (click)="toggleHelp()">
        <div class="help-page-title">{{ translations['helpPageTitle'] }}</div>
        <span
            class="help-page-toggle-icon"
            *ngIf="isPrecreatedBetBuilderEnabled && collapsible"
            [ngClass]="collapsed ? 'theme-info' : 'theme-info-i'"></span>
    </div>
    <div class="help-page-build-a-bet-info" [innerHTML]="helpPageContent"></div>
    <div class="help-page-toggle-wrap" *ngIf="!collapsed">
        <div class="example-title">{{ translations['exampleTitle'] }}</div>
        <div class="example">
            <div class="legs">
                <div class="market-leg" *ngFor="let leg of helpPageLegs">
                    <div class="circle-overlay"><div class="theme-radio-off"></div></div>
                    <span class="leg">{{ leg }}</span>
                </div>
            </div>
            <div class="event-name">{{ exampleEventName }}</div>
            <span class="odds">{{ exampleOdds }}</span>
        </div>
        <div class="help-page-footer">
            <div class="help-page-buttons" *ngIf="showHelpButtons">
                <button class="btn btn-primary" (click)="onOkClicked()">{{ okButtonText }}</button>
                <button class="btn btn-tertiary" [innerHTML]="helpPageLearnMoreLink" (click)="onLearnMoreClick()"></button>
            </div>
            <div class="help-page-link" [innerHTML]="helpPageLink"></div>
        </div>
    </div>
</div>
